/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum UserErrorDataKey {
  /**
   * User action error code
   */
  USER_ACTION_ERROR_CODE = 'error',
  /**
   * User action error message
   */
  USER_ACTION_ERROR_MESSAGE = 'error_message',
  /**
   * User action error description
   */
  USER_ACTION_ERROR_DESCRIPTION = 'error_description',
}
